import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
import { exportFile_Data, setState } from "../scenarioSetupNewSlice";
import dayjs from "dayjs";

export default function ExportExcelPDF() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.scenarioSetupNew);
	const {
		sentToSAP,
		selectedDSs,
		customerBreakdown,
		customerBreakdownType,
		selectedDefaultInitialForecast,
		emailNotification,
		selectedConsensus,
		selectedPreviousYear,
		selectedLinearTrend,
		periodType,
		scenarioName,
		dataSources,
		selectedCountry,
		countryID,
		skuBreakdown,
		//selectedCountryID,
		//selectedScenarioName,
		editMode,
        selectedScSTQ,
        selectedCustsCGs,
        selectedPGs,
        criticalityId,
        createFromDate,
        createToDate
	} = state;


	

	async function exportDataAsFile(isPdf) {
		if(countryID === undefined || countryID === null || countryID === ""){
			showMessage("Please select a country", "info");
		}
		else if(scenarioName === undefined || scenarioName === null || scenarioName === ""){
			showMessage("Please select a scenario name", "info");
		}
		else if(createFromDate === undefined || createFromDate === null || createFromDate === ""){
			showMessage("Please select a From date", "info");
		}
		else if(createToDate === undefined || createToDate === null || createToDate === ""){
			showMessage("Please select a To date", "info");
		}
		else if(selectedPGs === undefined || selectedPGs === null || selectedPGs.length === 0){
			showMessage("Please select a product or product group", "info");
		}
		else if(selectedCustsCGs === undefined || selectedCustsCGs === null || selectedCustsCGs.length === 0){
			showMessage("Please select a customer or customer group", "info");
		}
		else{
			let customersList = [];
			let customerGroupsList = [];
			let ProductsList = [];
			let ProductGroupsList = [];
            for (let i = 0; i < selectedCustsCGs.length; i++) {
                if (selectedCustsCGs[i].type === "C") {
                    let obj ={};
                    obj['customerID'] = selectedCustsCGs[i].id;
                    obj['customer'] = {};
                    obj['customer']['customerName']= selectedCustsCGs[i].name;
                    customersList.push(obj);
                }
                else if (selectedCustsCGs[i].type === "CG") {
                    let obj ={};
                    obj['customerGroupID'] = selectedCustsCGs[i].id;
                    obj['customerGroup'] = {};
                    obj['customerGroup']['customerGroupName']= selectedCustsCGs[i].name;
                    customerGroupsList.push(obj);
                }
                else if (selectedCustsCGs[i].hasOwnProperty("customerID")){
                    let obj ={};
                    obj['customerID'] = selectedCustsCGs[i].customerID;
                    obj['customer'] = {};
                    obj['customer']['customerName']= selectedCustsCGs[i].customerName;
                    customersList.push(obj);
                }
                else if (selectedCustsCGs[i].hasOwnProperty("customerGroupID")){
                    let obj ={};
                    obj['customerGroupID'] = selectedCustsCGs[i].customerGroupID;
                    obj['customerGroup'] = {};
                    obj['customerGroup']['customerGroupName']= selectedCustsCGs[i].customerGroupName;
                    customerGroupsList.push(obj);
                }
            }
            for (let i = 0; i < selectedPGs.length; i++) {
                if (selectedPGs[i].type === "P") {
                    let obj ={};
                    obj['sKUID'] = selectedPGs[i].id;
                    obj['product'] = {};
                    obj['product']['productName']= selectedPGs[i].name;
                    obj['product']['clientProductCode']= selectedPGs[i].cip;
                    ProductsList.push(obj);
                }
                else if (selectedPGs[i].type === "PG") {
                    let obj ={};
                    obj['productGroupID'] = selectedPGs[i].id;
                    obj['productGroup'] = {};
                    obj['productGroup']['productGroupName']= selectedPGs[i].name;
                    ProductGroupsList.push(obj);
                }
                else if (selectedPGs[i].hasOwnProperty("productID")) {
                    let obj ={};
                    obj['sKUID'] = selectedPGs[i].productID;
                    obj['product'] = {};
                    obj['product']['productName']= selectedPGs[i].name? selectedPGs[i].name : selectedPGs[i].productName;
                    obj['product']['clientProductCode']= selectedPGs[i].clientProductCode;
                    ProductsList.push(obj);
                }
                else if (selectedPGs[i].hasOwnProperty("productGroupID")){
                    let obj ={};
                    obj['productGroupID'] = selectedPGs[i].productGroupID;
                    obj['productGroup'] = {};
                    obj['productGroup']['productGroupName']= selectedPGs[i].productGroupName;
                    ProductGroupsList.push(obj);
                }
            }
			let datasources = [];
			for (let i = 0; i < selectedDSs.length; i++) {
				datasources.push(dataSources.find((source) => source.dataSourceName === selectedDSs[i]));
			}
			
			const data = JSON.parse(localStorage.getItem("data"));
			let postData = {
				isPdf,
				countryID : countryID,//
				countryName : selectedCountry,
				customerBreakdown : customerBreakdown,
				customerBreakdownType: customerBreakdownType,
				skuBreakdown : skuBreakdown,
				defaultInitialForecast: selectedDefaultInitialForecast,
				emailNotification: emailNotification,
				financialFCTimePeriod: selectedConsensus,
				linearFCTimePeriod:selectedLinearTrend,
				// lstScenarioCustomerGroups: "",
				// lstScenarioCustomers: "2966808",
				// lstScenarioProducts: "",
				// lstScenarioSKUs: "40145,40147,40148",
				manuallyDefinedShare: [],
				modificationDeviationPercentage: 0,
				periodType: periodType,
				previousYearTimePeriod: selectedPreviousYear,
				scenarioName: scenarioName,
				userid : data.userID,
				roleName: data.roleName,
				isEdit: editMode,
				email: data.email,
				displayStickToQuota : selectedScSTQ === "Enabled" ? 1 : 0,
				sentToSAP: sentToSAP ? "N" : "NA",
				SentToSAP4PLExport : sentToSAP ? 0 : 1,
				stickToQuota : selectedScSTQ === "Enabled" ? 1 : 0,
				scenarioDatasource : datasources,//selectedDSs,
				customers: customersList,
				customerGroups : customerGroupsList,
				product: ProductsList,
				productGroup : ProductGroupsList,
				criticalityId : criticalityId,
				scenarioStatus : "Invalid",
				effectiveStartDate : changeDateFormat(createFromDate),
				effectiveEndDate: changeDateFormat(createToDate),
				updatedBy: data.firstName + " " + data.lastName,
				updatedDate: changeDateFormat(dayjs()),
			};
			dispatch(exportFile_Data(postData));
		}
	}
    const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};
	const changeDateFormat = (date) => {
		const year = date.year();
		const month =
			date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
		const day = date.date() < 10 ? `0${date.date()}` : date.date();
		const time = "T00:00:00.000Z";
		const d = `${year}-${month}-${day}${time}`;
		return d;
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
				}}
			>
				<IconButton onClick={(e) => exportDataAsFile(false)}>
					<GridOnIcon sx={{ color: "green.main" }} />
				</IconButton>
				<IconButton onClick={(e) => exportDataAsFile(true)}>
					<PictureAsPdfIcon sx={{ color: "red.main" }} />
				</IconButton>
			</Box>
		</Box>
	);
}
